import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import angular = require('angular');
import * as _ from 'underscore';
import { IPaginationShopTables, IStoreTableModel, ITableSettings, TableSettingEnum } from '../../models';
import { ShopService } from '../../shop.service';

export class ShopTables implements ng.IController {
    public static $inject = ['shopService', '$state', '$scope'];

    public shopId: number;
    public shopName: string;
    public shopTown: string;
    public tableSettings: ITableSettings = {TableOrderEnabled: false, TableSelectionMandatory: false};
    public waiting: boolean = false;
    public tableSettingsOptions = TableSettingEnum;

    public tables: IStoreTableModel[] = [];
    public total: number;

    public pagination: IPaginationShopTables = {
        data: [],
        page: 1,
        pageSize: 5,
        total: 0,
        setData: () => {
            this.pagination.total = this.total;
            this.pagination.data = this.tables.slice(this.pagination.pageSize * (this.pagination.page - 1), this.pagination.pageSize * this.pagination.page);
            while (this.pagination.total > 0 && _.size(this.pagination.data) === 0) {
                this.pagination.page--;
                this.pagination.data = this.tables.slice(this.pagination.pageSize * (this.pagination.page - 1), this.pagination.pageSize * this.pagination.page);
            }
        }
    };

    constructor(
        private shopService: ShopService,
        private $state: StateService,
        private $scope: ng.IScope
    ) {
    }

    public async $onInit() {
        this.loadTablesEnabled().then();
        this.loadTables().then();
    }

    public async loadTablesEnabled() {
        this.waiting = true;
        try {
            this.tableSettings = await this.shopService.getTablesEnabled(this.shopId);
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
    }

    public async loadTables() {
        this.waiting = true;
        try {
            const response = await this.shopService.getTables(this.shopId);
            this.tables = response.Items;
            this.total = response.Total;
            this.$scope.$watchGroup(['ctrl.pagination.page'], (value) => {
                if (value) {
                    this.pagination.setData();
                }
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
    }

    public addTable() {
        this.$state.go('app.shopTables', { id: this.shopId, shopName: this.shopName, openAddTable: true, shopTown: this.shopTown });
    }

    public async changeTableSettings(settingsValue: number, parameter: boolean) {
        const currentParameter = !parameter;

        if (settingsValue === this.tableSettingsOptions.TableService) {
            await this.setTablesEnabled(currentParameter);
        } else {
            await this.setTablesMandatory(currentParameter);
        }

        if (settingsValue === this.tableSettingsOptions.TableService) {
            this.tableSettings.TableOrderEnabled = currentParameter;
            if (!this.tableSettings.TableOrderEnabled && this.tableSettings.TableSelectionMandatory) {
                await this.setTablesMandatory(false);
                this.tableSettings.TableSelectionMandatory = false;
            }
        } else if (settingsValue === this.tableSettingsOptions.TableMandatorySelection) {
            this.tableSettings.TableSelectionMandatory = currentParameter;
        }
    }

    public openTablesList() {
        this.$state.go('app.shopTables', { id: this.shopId, shopName: this.shopName, shopTown: this.shopTown });
    }

    private async setTablesEnabled(isEnabled: boolean) {
        try {
            this.waiting = true;
            await this.shopService.setTablesEnabled(this.shopId, isEnabled);
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
    }

    private async setTablesMandatory(isMandatory: boolean) {
        try {
            this.waiting = true;
            await this.shopService.setTablesMandatory(this.shopId, isMandatory);
        } catch (error) {
            console.log(error);
        } finally {
            this.waiting = false;
        }
    }

}

angular.module('naut').component('shopTables', {
    template: require('./shop-tables.component.html'),
    controller: ShopTables,
    controllerAs: 'ctrl',
    bindings: {
        shopId: '<',
        shopName: '<',
        shopTown: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/places/components/shop-tables/shop-tables.component.ts